<section class="mobile-view p-10">
  <p-selectButton
    [options]="navOptions"
    [unselectable]="true"
    [(ngModel)]="selectedNavOption"
    styleClass="mobile-view__nav"
  />
  <div class="mobile-view__content">
    @if (selectedNavOption === 'Transcript') {
      <cv-transcriptions></cv-transcriptions>
    } @else {
      <div [@routeAnimations]="page.activatedRouteData['animation']" class="pr-10">
        <router-outlet #page="outlet"></router-outlet>
      </div>
    }
  </div>
</section>
